import { axiosInstance } from './config/instance'
import { SERVER } from './config/url'

const API_REFERRAL_URL = `${SERVER}/referral-backend-console/api/v1`

export const referral = Object.freeze({
  async fetchCatalog() {
    const response = await axiosInstance.get(`${API_REFERRAL_URL}/catalog/admin`)

    if (response.status === 200 && Array.isArray(response.data)) {
      return response.data
    } else {
      return []
    }
  },
  async fetchTransfer(data) {
    const response = await axiosInstance.post(`${API_REFERRAL_URL}/transfer/admin/search`, data)
    return response.data
  },
  async fetchRef(id) {
    const response = await axiosInstance.get(`${API_REFERRAL_URL}/ref/admin/${id}`)
    return response.data
  },
  async fetchTransferCustomer(id) {
    const response = await axiosInstance.get(`${API_REFERRAL_URL}/transfer/admin/${id}`)
    return response.data
  },
  async fetchTransferCustomerSearch(id) {
    const response = await axiosInstance.get(`${API_REFERRAL_URL}/transfer/admin/${id}`)
    return response.data
  },
  async process(id) {
    const response = await axiosInstance.put(`${API_REFERRAL_URL}/transfer/admin/${id}/process`)
    return response.data
  },
  async refund(id) {
    const response = await axiosInstance.put(`${API_REFERRAL_URL}/transfer/admin/${id}/refund`)
    return response.data
  },
  async fetchCatalogItem(id) {
    const response = await axiosInstance.get(`${API_REFERRAL_URL}/catalog/admin/${id}`)
    return response.data
  },
  async createCatalogItem(data) {
    const response = await axiosInstance.post(`${API_REFERRAL_URL}/catalog/admin/add`, [data])
    return response.data
  },
  async updateCatalogItem(id, data) {
    const response = await axiosInstance.put(`${API_REFERRAL_URL}/catalog/admin/${id}`, data)
    return response.data
  },
  async deleteCatalogItem(id) {
    const response = await axiosInstance.delete(`${API_REFERRAL_URL}/catalog/admin/remove/${id}`)
    return response.data
  },
  async fetchCustomerItem(id) {
    const response = await axiosInstance.get(`${API_REFERRAL_URL}/customer/admin/${id}`)
    return response.data
  },
  async fetchEvents(id) {
    const response = await axiosInstance.get(`${API_REFERRAL_URL}/events/admin/view/${id}`)
    return response.data
  },
  async fetchSettings() {
    const response = await axiosInstance.get(`${API_REFERRAL_URL}/settings/admin`)
    return response.data
  },
  async updateSettings({ id, data }) {
    const response = await axiosInstance.put(`${API_REFERRAL_URL}/settings/admin/${id}`, data)
    return response.data
  },
  async fetchCustomerRelatedBy(id) {
    const response = await axiosInstance.get(`${API_REFERRAL_URL}/customer/admin/relatedBy/${id}`)
    return response.data
  },
  async rewardDistribution(data) {
    const response = await axiosInstance.post(
      `${API_REFERRAL_URL}/customer/admin/rewardDistribution`,
      data
    )
    return response.data
  },
})
